/* Shared by the B preview and Shopify. A set remains one purchasable item. */
(() => {
  'use strict';
  if (customElements.get('chura-flavor-mixer')) return;
  const flavors = [
    {key:'plain',label:'プレーン',short:'米糀',taste:'お米のやさしい甘み'},
    {key:'shikuwasa',label:'沖縄シークヮーサー',short:'柑橘',taste:'きゅっと爽やかな酸味'},
    {key:'pineapple',label:'沖縄パイナップル',short:'パイン',taste:'華やかな南国の香り'},
    {key:'roselle',label:'沖縄ローゼル',short:'ローゼル',taste:'ほのかな甘酸っぱさ'}
  ];
  class ChuraFlavorMixer extends HTMLElement {
    static get observedAttributes() { return ['total']; }
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.innerHTML = `<fieldset class="mix-fieldset"><legend>03　好きな味を、好きな本数で</legend>
        <p class="mix-intro">4種を少しずつでも、好きな1種だけでも。<br>セット本数に合わせて自由に組み合わせられます。</p>
        <div class="mix-presets"><button type="button" data-mix-balanced>4種をバランスよく</button><button type="button" data-mix-clear>すべてクリア</button></div>
        <div class="mix-rows">${flavors.map(f=>`<div class="mix-row mix-${f.key}">
          <span class="mix-swatch" data-mix-picture="${f.key}">${f.short}</span>
          <div class="mix-info"><strong>${f.label}</strong><small>${f.taste}</small></div>
          <div class="mix-stepper"><button type="button" data-mix-minus="${f.key}" aria-label="${f.label}を1本減らす">−</button><label><span class="mix-sr-only">${f.label}の本数</span><input type="number" inputmode="numeric" min="0" step="1" value="0" data-mix-input="${f.key}" aria-label="${f.label}の本数"><span class="mix-unit">本</span></label><button type="button" data-mix-plus="${f.key}" aria-label="${f.label}を1本増やす">＋</button></div>
          <input type="hidden" name="properties[${f.label}]" data-mix-property="${f.key}" disabled>
        </div>`).join('')}</div>
        <div class="mix-status-box"><div class="mix-count-line"><span>選んだ本数</span><p><strong data-mix-selected>0</strong><span> / <b data-mix-target>7</b>本</span></p></div><div class="mix-progress" aria-hidden="true"><span data-mix-progress></span></div><p class="mix-message" data-mix-message role="status" aria-live="polite" aria-atomic="true"></p><p class="mix-summary" data-mix-summary></p></div>
      </fieldset>`;
      this.inputs = new Map(flavors.map(f=>[f.key,this.querySelector(`[data-mix-input="${f.key}"]`)]));
      for (const f of flavors) {
        const image = this.getAttribute(`data-${f.key}-image`);
        if (image) {
          const img = document.createElement('img');
          img.src = image;
          img.alt = '';
          img.width = 56;
          img.height = 64;
          img.loading = 'lazy';
          this.querySelector(`[data-mix-picture="${f.key}"]`).replaceChildren(img);
        }
        this.inputs.get(f.key).addEventListener('input',()=>this.update());
        for (const [action,delta] of [['minus',-1],['plus',1]]) {
          this.querySelector(`[data-mix-${action}="${f.key}"]`).addEventListener('click',()=>{
            const input = this.inputs.get(f.key);
            const current = /^\d+$/.test(input.value) ? Number(input.value) : 0;
            input.value = String(Math.max(0,current+delta));
            this.update();
          });
        }
      }
      this.querySelector('[data-mix-balanced]').addEventListener('click',()=>{
        const count = this.target;
        flavors.forEach((f,index)=>{this.inputs.get(f.key).value=String(Math.floor(count/4)+(index<count%4?1:0));});
        this.update();
      });
      this.querySelector('[data-mix-clear]').addEventListener('click',()=>{
        this.inputs.forEach(input=>{input.value='0';});
        this.update();
      });
      this.update();
    }
    attributeChangedCallback() { if (this.initialized) this.update(); }
    get target() {
      const value = Number(this.getAttribute('total'));
      return [7,14,21,28].includes(value) ? value : 0;
    }
    setSize(count) { this.setAttribute('total',String(count)); }
    getState() {
      const target = this.target;
      const counts = {};
      let integers = true;
      for (const f of flavors) {
        const raw = this.inputs?.get(f.key)?.value ?? '';
        const value = /^\d+$/.test(raw) ? Number(raw) : NaN;
        const validNumber = Number.isSafeInteger(value) && value >= 0 && value <= 28;
        counts[f.key] = validNumber ? value : null;
        integers = integers && validNumber;
      }
      const total = Object.values(counts).reduce((sum,n)=>sum+(n??0),0);
      const valid = target>0 && integers && total===target;
      let message;
      if (!target) message='先にセット本数を選んでください。';
      else if (!integers) message='各味の本数を0〜28の整数で入力してください。';
      else if (total>target) message=`${total-target}本多く選ばれています。合計${target}本に調整してください。`;
      else if (total<target) message=`あと${target-total}本選べます。`;
      else message=`${target}本の組み合わせができました。`;
      const summary = flavors.filter(f=>(counts[f.key]??0)>0).map(f=>`${f.label} ${counts[f.key]}本`).join('／');
      return {valid,total,target,counts,message,summary};
    }
    update() {
      const state = this.getState();
      const allIntegers = Object.values(state.counts).every(n=>n!==null);
      this.dataset.complete = String(state.valid);
      this.dataset.over = String(!allIntegers || state.total>state.target);
      this.querySelector('[data-mix-selected]').textContent = allIntegers ? String(state.total) : '—';
      this.querySelector('[data-mix-target]').textContent = String(state.target);
      this.querySelector('[data-mix-message]').textContent = state.message;
      this.querySelector('[data-mix-summary]').textContent = state.summary || 'お好みの味を選んでください。';
      this.querySelector('[data-mix-progress]').style.width = `${state.target?Math.min(100,state.total/state.target*100):0}%`;
      this.querySelector('[data-mix-balanced]').disabled = !state.target;
      for (const f of flavors) {
        const input = this.inputs.get(f.key);
        input.max = String(state.target || 28);
        input.disabled = !state.target;
        const count = state.counts[f.key];
        input.setAttribute('aria-invalid',String(count===null || count>state.target));
        input.setCustomValidity(count===null?'0〜28の整数を入力してください。':'');
        this.querySelector(`[data-mix-minus="${f.key}"]`).disabled = !state.target || count===0;
        this.querySelector(`[data-mix-plus="${f.key}"]`).disabled = !state.target || !allIntegers || state.total>=state.target;
        const property = this.querySelector(`[data-mix-property="${f.key}"]`);
        property.value = `${count??0}本`;
        property.disabled = !state.valid;
      }
      this.dispatchEvent(new CustomEvent('flavorchange',{bubbles:true,detail:state}));
    }
  }
  customElements.define('chura-flavor-mixer',ChuraFlavorMixer);
})();
